import { API_BASE_URL } from '../config/config';

/**
 * Service to handle vehicle traceability data
 */
export const traceabilityConfigService = {
    /**
     * Fetches the traceability history for a given vehicle VIN/Registry
     * @param {string} vin - The vehicle identification number
     * @returns {Promise<Object>} The traceability data
     */
    getVehicleTraceability: async (vin) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/tracking/vin/${vin}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
                }
            });

            if (!response.ok) {
                console.warn(`Traceability API error: ${response.status} ${response.statusText}`);
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error fetching traceability data:', error);
            throw error;
        }
    },

    /**
     * Fetches historical traceability data with filters
     * @param {Object} params - Query parameters (fecha, fecha_inicio, fecha_fin, mes, ano, page, page_size)
     * @returns {Promise<Object>} The historical data
     */
    getHistoricalTraceability: async (params = {}) => {
        try {
            // Filter out null/undefined values
            const queryParams = Object.entries(params)
                .filter(([_, value]) => value != null && value !== '')
                .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                .join('&');

            const url = `${API_BASE_URL}/api/tracking/historico/?${queryParams}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
                }
            });

            if (!response.ok) {
                console.warn(`Historical traceability API error: ${response.status} ${response.statusText}`);
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error fetching historical traceability:', error);
            throw error;
        }
    }
};

/**
 * Generates mock data for development
 */
const getMockData = (vin) => {
    return {
        "vin": vin || "LGWCB6198TJ612539",
        "vehiculo_info": {
            "marca": "FORD",
            "familia": "BRONCO",
            "ano_modelo": "2025",
            "catalogo": "BR1"
        },
        "resumen": {
            "distancia_total_km": 25.5,
            "consumo_total_litros": 2.43,
            "total_segmentos": 3
        },
        "segmentos": [
            {
                "segmento": 1,
                "origen": {
                    "patio_id": 13,
                    "patio_nombre": "2kodapatio",
                    "fecha": "2025-12-02T06:55:58.063413+00:00",
                    "tipo_lectura": "antena"
                },
                "destino": {
                    "patio_id": null,
                    "patio_nombre": "IP 192.168.1.51",
                    "fecha": "2025-12-02T06:57:35.245624+00:00",
                    "tipo_lectura": "antena"
                },
                "distancia_km": 12.5,
                "consumo_km_l": 10.5,
                "litros_consumidos": 1.19
            },
            {
                "segmento": 2,
                "origen": {
                    "patio_id": null,
                    "patio_nombre": "IP 192.168.1.51",
                    "fecha": "2025-12-02T07:15:00.000000+00:00",
                    "tipo_lectura": "pistola"
                },
                "destino": {
                    "patio_id": 14,
                    "patio_nombre": "Patio Salida",
                    "fecha": "2025-12-02T08:30:00.000000+00:00",
                    "tipo_lectura": "antena"
                },
                "distancia_km": 13.0,
                "consumo_km_l": 11.0,
                "litros_consumidos": 1.24
            }
        ]
    };
};
